module.exports = __webpack_public_path__ + "media/images/icon__community-693400141c8b0c18d9da7e69f01545b9.png";